import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPricePipe',
  standalone: false,
})
export class FormatPricePipe implements PipeTransform {
  transform(price: number | undefined): string | null {
    if (price != null) {
      return `${price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} €`;
    } else {
      return null;
    }
  }
}
